<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18nStore } from '@/composition/i18nStore'

const { getters: i18nGetters } = useI18nStore()
const props = defineProps({
  to: { type: String, required: true },
})

const localizedUrl = computed(() => {
  const locale = i18nGetters.currentLocale.value
  return props.to === '/' ? `/${locale}` : `/${locale}/${props.to}`
})
</script>

<template>
  <RouterLink :to="localizedUrl">
    <slot></slot>
  </RouterLink>
</template>
